import React, { useState } from "react";
import { IconButton, Tooltip, Menu, MenuItem, Divider, Typography } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

/**
 * options: [{ label: string, value?: any, icon?: ReactNode, color?: "default"|"error" }]
 * onSelect(option, guid)
 */
export default function ActionsMenu({ options = [], onSelect, guid, tooltip = "Actions" }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleSelect = (option) => {
        onSelect?.(option, guid);
        handleClose();
    };

    const renderLabel = (option) => (
        <Typography
            variant="body2"
            sx={{
                fontWeight: option?.color === "error" ? 700 : 500,
            }}
        >
            {option.label}
        </Typography>
    );

    return (
        <>
            <Tooltip title={tooltip}>
                <IconButton
                    id="dropdown-button"
                    aria-controls={open ? "dropdown-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                    size="small"
                    sx={{
                        borderRadius: 2,
                        border: "1px solid",
                        borderColor: "divider",
                    }}
                >
                    <MoreVertIcon fontSize="small" />
                </IconButton>
            </Tooltip>

            <Menu
                id="dropdown-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{ "aria-labelledby": "dropdown-button" }}
                PaperProps={{
                    sx: {
                        borderRadius: 2,
                        minWidth: 220,
                        overflow: "hidden",
                    },
                }}
            >
                {options.map((option, index) => {
                    if (option?.type === "divider") {
                        return <Divider key={`div-${index}`} />;
                    }

                    const isDanger = option?.color === "error";

                    return (
                        <MenuItem
                            key={index}
                            dense
                            onClick={() => handleSelect(option)}
                            sx={{
                                color: isDanger ? "error.main" : "text.primary",
                                gap: 1.25,
                                py: 1,
                            }}
                        >
                            {option.icon ? (
                                <span style={{ display: "inline-flex", alignItems: "center" }}>
                                    {option.icon}
                                </span>
                            ) : null}

                            {renderLabel(option)}
                        </MenuItem>
                    );
                })}
            </Menu>
        </>
    );
}
